<template>
  <div class="custom-list-wrapper">
    <div v-if="loadingContact">
      <span>Loading...</span>
    </div>
    <div class="custom-list-header" v-show="!loadingContact">
      <b-button variant="outline-secondary" size="sm" @click="newPhone" class="margin-right-5">Add</b-button>
      <b-button variant="outline-secondary" size="sm" @click="confirmDelete" v-show="isShowDelete"
        class="margin-right-5">Delete</b-button>
      <b-button variant="outline-secondary" size="sm" @click="primaryPhone"
        v-show="isShowPrimary && recordChecked && !recordChecked.isPrimary" class="margin-right-5">Set as
        Primary</b-button>
      <span class="custom-title" v-show="showTitle">Phones</span>
    </div>
    <div class="custom-list" v-show="!loadingContact">
      <div v-for="item of contactPhones" :key="item.contactPhone">
        <ContactPhoneRecord :recordData="item" @itemChecked="itemChecked" @editItem="editPhone" />
      </div>
    </div>
    <DialogPhone v-model="actionPhone" :value="actionPhone" :phone="phoneRecord" @closing="closeModal"
      @send="sendPhone" />
    <ConfirmDelete v-model="actionDelete" :value="actionDelete" :tag="'Phone(s)'" @closing="closeModal"
      @delete="performDelete" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { contacts } from '@/stores'
import DialogPhone from '@/components/contacts/forms/phone.vue'
import ContactPhoneRecord from '@/components/contacts/listings/contact-phone-record.vue'
import ConfirmDelete from '@/components/contacts/forms/confirm-delete.vue'
export default {
  name: 'contact-phones',
  components: {
    DialogPhone,
    ContactPhoneRecord,
    ConfirmDelete
  },
  props: {
    contact: {
      type: Object
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actionPhone: null,
      actionDelete: null,
      isShowDelete: false,
      isShowPrimary: false,
      recordChecked: null,
      phoneRecord: undefined
    }
  },
  computed: {
    ...mapState(contacts, ['contactPhones', 'loadingContact'])
  },
  methods: {
    ...mapActions(contacts, [
      'savePhone',
      'deletePhone',
      'setPrimaryPhone',
      'setCheckedPhone',
      'getContactPhones',
      'addPhone'
    ]),
    closeModal() {
      this.actionPhone = null
      this.actionDelete = null
      this.phoneRecord = undefined
      this.recordChecked = null
    },
    itemChecked(value, checked) {
      this.isShowDelete = checked
      this.isShowPrimary = checked
      this.recordChecked = null
      if (checked) {
        this.recordChecked = value
      }
      this.setCheckedPhone({
        contactPhone: value.contactPhone,
        isChecked: checked
      })
    },
    newPhone() {
      var phone = {
        firm: this.contact.firm,
        contact: this.contact.contact,
        contactPhone: -1,
        extension: '',
        isShared: false,
        phone: -1,
        phoneNo: '',
        phoneNote: '',
        phoneType: 0,
        phoneTypeName: '',
        primary: ''
      }
      this.addPhone(phone)
      this.phoneRecord = phone
      this.actionPhone = this.contact
    },
    editPhone(data) {
      this.phoneRecord = data
      this.actionPhone = this.contact
    },
    confirmDelete() {
      this.actionDelete = true
    },
    async performDelete() {
      this.actionDelete = false
      this.isShowDelete = false
      this.isShowPrimary = false
      this.recordChecked = null
      let phones = []
      for (let phone of this.contactPhones) {
        if (phone.isChecked) {
          phones.push({
            contactPhone: phone.contactPhone,
            contact: this.contact.contact
          })
        }
      }
      for (let phone of phones) {
        await this.deletePhone(phone)
      }
      await this.getContactPhones(this.contact.contact)
    },
    async primaryPhone() {
      let data = {
        id: this.recordChecked.contactPhone,
        contact: this.contact.contact
      }
      await this.setPrimaryPhone(data)
      this.isShowDelete = false
      this.isShowPrimary = false
      this.recordChecked = null
    },
    async sendPhone(data) {
      this.actionPhone = null
      this.phoneRecord = undefined
      var phone = this.contactPhones.find(
        x => parseInt(x.contactPhone) === parseInt(data)
      )
      if (phone !== null) {
        if (phone.phone === -1) {
          phone.isPrimary = true
        }
        if('isShared' in phone){
        if(typeof phone.isShared == 'string' && phone.isShared == ""){
          phone.isShared = null
        }
        if(typeof phone.isShared == 'string' && phone.isShared == "true"){
          phone.isShared = true
        }
        if(typeof phone.isShared == 'string' && phone.isShared == "false"){
          phone.isShared = false
        }
      }
        await this.savePhone(phone)
        await this.getContactPhones(this.contact.contact)
        this.$emit('onupdate', this.contact.contact)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list-wrapper {
  background-color: #ffffff;
  max-height: 210px;
  height: 210px;
  padding: 2px;
}

.custom-list-header {
  text-align: left;
  padding: 5px;
  border-bottom: 1px solid rgb(144, 144, 144);
  margin-bottom: 5px;
}

.custom-list {
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;
  margin-left: 5px;
  margin-right: 5px;
  height: 155px;
}

.custom-title {
  float: right;
  position: relative;
}
</style>
